import Component from "@glimmer/component";
import { hash } from "@ember/helper";
import { service } from "@ember/service";
import { htmlSafe } from "@ember/template";
import PluginOutlet from "discourse/components/plugin-outlet";
import { addExtraUserClasses, renderAvatar } from "discourse/helpers/user-avatar";
import { applyValueTransformer } from "discourse/lib/transformer";
import icon from "discourse-common/helpers/d-icon";
import i18n from "discourse-common/helpers/i18n";
import UserTip from "../../user-tip";
import UserStatusBubble from "./user-status-bubble";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
const DEFAULT_AVATAR_SIZE = "medium";
export default class Notifications extends Component {
  static #_ = (() => dt7948.g(this.prototype, "currentUser", [service]))();
  #currentUser = (() => (dt7948.i(this, "currentUser"), void 0))();
  static #_2 = (() => dt7948.g(this.prototype, "siteSettings", [service]))();
  #siteSettings = (() => (dt7948.i(this, "siteSettings"), void 0))();
  get avatar() {
    const avatarAttrs1 = addExtraUserClasses(this.currentUser, {});
    return htmlSafe(renderAvatar(this.currentUser, {
      imageSize: this.avatarSize,
      title: i18n("user.avatar.header_title"),
      template: this.currentUser.avatar_template,
      username: this.currentUser.username,
      name: this.siteSettings.enable_names && this.currentUser.name,
      ...avatarAttrs1
    }));
  }
  get avatarSize() {
    return applyValueTransformer("header-notifications-avatar-size", DEFAULT_AVATAR_SIZE);
  }
  get _shouldHighlightAvatar() {
    return !this.currentUser.read_first_notification && !this.currentUser.enforcedSecondFactor && !this.args.active;
  }
  get isInDoNotDisturb() {
    return this.currentUser.isInDoNotDisturb();
  }
  static #_3 = (() => setComponentTemplate(createTemplateFactory(
  /*
    
      <PluginOutlet @name="user-dropdown-notifications__before" />
      {{this.avatar}}
  
      {{#if this._shouldHighlightAvatar}}
        <UserTip
          @id="first_notification"
          @triggerSelector=".header-dropdown-toggle.current-user"
          @placement="bottom-end"
          @titleText={{i18n "user_tips.first_notification.title"}}
          @contentText={{i18n "user_tips.first_notification.content"}}
          @showSkipButton={{true}}
        />
      {{/if}}
  
      {{#if this.currentUser.status}}
        <UserStatusBubble
          @timezone={{this.this.currentUser.user_option.timezone}}
          @status={{this.currentUser.status}}
        />
      {{/if}}
  
      {{#if this.isInDoNotDisturb}}
        <div class="do-not-disturb-background">{{icon "discourse-dnd"}}</div>
      {{else}}
        {{#if this.currentUser.new_personal_messages_notifications_count}}
          <a
            href="#"
            class="badge-notification with-icon new-pms"
            title={{i18n
              "notifications.tooltip.new_message_notification"
              (hash
                count=this.currentUser.new_personal_messages_notifications_count
              )
            }}
            aria-label={{i18n
              "notifications.tooltip.new_message_notification"
              (hash
                count=this.currentUser.new_personal_messages_notifications_count
              )
            }}
          >
            {{icon "envelope"}}
          </a>
        {{else if this.currentUser.unseen_reviewable_count}}
          <a
            href="#"
            class="badge-notification with-icon new-reviewables"
            title={{i18n
              "notifications.tooltip.new_reviewable"
              (hash count=this.currentUser.unseen_reviewable_count)
            }}
            aria-label={{i18n
              "notifications.tooltip.new_reviewable"
              (hash count=this.currentUser.unseen_reviewable_count)
            }}
          >
            {{icon "flag"}}
          </a>
        {{else if this.currentUser.all_unread_notifications_count}}
          <a
            href="#"
            class="badge-notification unread-notifications"
            title={{i18n
              "notifications.tooltip.regular"
              (hash count=this.currentUser.all_unread_notifications_count)
            }}
            aria-label={{i18n
              "user.notifications"
              (hash count=this.currentUser.all_unread_notifications_count)
            }}
          >
            {{this.currentUser.all_unread_notifications_count}}
          </a>
        {{/if}}
      {{/if}}
      <PluginOutlet @name="user-dropdown-notifications__after" />
    
  */
  {
    "id": "sq3tBnKT",
    "block": "[[[1,\"\\n    \"],[8,[32,0],null,[[\"@name\"],[\"user-dropdown-notifications__before\"]],null],[1,\"\\n    \"],[1,[30,0,[\"avatar\"]]],[1,\"\\n\\n\"],[41,[30,0,[\"_shouldHighlightAvatar\"]],[[[1,\"      \"],[8,[32,1],null,[[\"@id\",\"@triggerSelector\",\"@placement\",\"@titleText\",\"@contentText\",\"@showSkipButton\"],[\"first_notification\",\".header-dropdown-toggle.current-user\",\"bottom-end\",[28,[32,2],[\"user_tips.first_notification.title\"],null],[28,[32,2],[\"user_tips.first_notification.content\"],null],true]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"currentUser\",\"status\"]],[[[1,\"      \"],[8,[32,3],null,[[\"@timezone\",\"@status\"],[[30,0,[\"currentUser\",\"user_option\",\"timezone\"]],[30,0,[\"currentUser\",\"status\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"isInDoNotDisturb\"]],[[[1,\"      \"],[10,0],[14,0,\"do-not-disturb-background\"],[12],[1,[28,[32,4],[\"discourse-dnd\"],null]],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"currentUser\",\"new_personal_messages_notifications_count\"]],[[[1,\"        \"],[10,3],[14,6,\"#\"],[14,0,\"badge-notification with-icon new-pms\"],[15,\"title\",[28,[32,2],[\"notifications.tooltip.new_message_notification\",[28,[32,5],null,[[\"count\"],[[30,0,[\"currentUser\",\"new_personal_messages_notifications_count\"]]]]]],null]],[15,\"aria-label\",[28,[32,2],[\"notifications.tooltip.new_message_notification\",[28,[32,5],null,[[\"count\"],[[30,0,[\"currentUser\",\"new_personal_messages_notifications_count\"]]]]]],null]],[12],[1,\"\\n          \"],[1,[28,[32,4],[\"envelope\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"currentUser\",\"unseen_reviewable_count\"]],[[[1,\"        \"],[10,3],[14,6,\"#\"],[14,0,\"badge-notification with-icon new-reviewables\"],[15,\"title\",[28,[32,2],[\"notifications.tooltip.new_reviewable\",[28,[32,5],null,[[\"count\"],[[30,0,[\"currentUser\",\"unseen_reviewable_count\"]]]]]],null]],[15,\"aria-label\",[28,[32,2],[\"notifications.tooltip.new_reviewable\",[28,[32,5],null,[[\"count\"],[[30,0,[\"currentUser\",\"unseen_reviewable_count\"]]]]]],null]],[12],[1,\"\\n          \"],[1,[28,[32,4],[\"flag\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"currentUser\",\"all_unread_notifications_count\"]],[[[1,\"        \"],[10,3],[14,6,\"#\"],[14,0,\"badge-notification unread-notifications\"],[15,\"title\",[28,[32,2],[\"notifications.tooltip.regular\",[28,[32,5],null,[[\"count\"],[[30,0,[\"currentUser\",\"all_unread_notifications_count\"]]]]]],null]],[15,\"aria-label\",[28,[32,2],[\"user.notifications\",[28,[32,5],null,[[\"count\"],[[30,0,[\"currentUser\",\"all_unread_notifications_count\"]]]]]],null]],[12],[1,\"\\n          \"],[1,[30,0,[\"currentUser\",\"all_unread_notifications_count\"]]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]],null]],[]]]],[]]]],[]]],[1,\"    \"],[8,[32,0],null,[[\"@name\"],[\"user-dropdown-notifications__after\"]],null],[1,\"\\n  \"]],[],false,[\"if\"]]",
    "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/header/user-dropdown/notifications.js",
    "scope": () => [PluginOutlet, UserTip, i18n, UserStatusBubble, icon, hash],
    "isStrictMode": true
  }), this))();
}